var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "input-container",
      class: { "required-fail": _vm.requiredFail }
    },
    [
      _c(
        "v-radio-group",
        {
          staticClass: "radio-input",
          attrs: {
            value: _vm.value,
            "input-value": _vm.value,
            column: _vm.radioInColumn,
            "hide-details": true
          },
          on: {
            change: function($event) {
              return _vm.updateValue($event)
            }
          }
        },
        _vm._l(_vm.radioOptions, function(option) {
          return _c("v-radio", {
            key: option.label,
            attrs: {
              label: option.label,
              value: _vm.convertedValue(option.value),
              ripple: false,
              color: "accent",
              disabled: _vm.disabled
            }
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f7f25e44", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7f25e44","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Npv/Configuration/components/InputTypesNPV/InputTypeRadioNPV.vue
// module id = null
// module chunks = 